import * as R from 'ramda';

export const descSort = R.sort((a: number, b: number) => b - a);
